import {createApp} from 'vue'
import App from './App.vue'
import "amfe-flexible"
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import './assets/css/base.css';

createApp(App).use(router).use(Antd).mount('#app')
